module.exports = __webpack_public_path__ + "static/media/k2.365427ed.jpg";